module.exports = __webpack_public_path__ + "img/sidebar1.png";